import { Link, NavLink } from "react-router-dom";
import { Logout } from "../../../utils/Logout";
import { useState } from "react";

const OfHeader = ({ bar, me, setSearch, geolocation, setGeolocation, provincias, onClick, getParams, navigate }) => {
  const [openDropdown, setOpenDropdown] = useState(null);

  const toggleDropdown = (id) => {
    setOpenDropdown(openDropdown === id ? null : id);
  };

  return (
    <div
      className="offcanvas offcanvas-start"
      tabIndex="-1"
      id="offcanvasTop-header"
      aria-labelledby="offcanvasTopLabel"
      style={{width: '300px'}}
    >
      <div className="offcanvas-header py-4 border-bottom">
        <div className="d-flex align-items-center gap-2">
          <img src="/assets/img/marca/antesala-logo.svg" width="40px" alt="Antesala" />
          <h5 className="offcanvas-title m-0 fw-bold" id="offcanvasTopLabel-header">
            Menú
          </h5>
        </div>
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
        ></button>
      </div>
      <div className="offcanvas-body p-0">
        {/* Search Section */}
        <div className="p-3 border-bottom bg-light">
          <div className="input-group">
            <span className="input-group-text bg-white border-end-0">
              <i className="bi bi-search text-muted"></i>
            </span>
            <input
              className="form-control border-start-0"
              style={{ borderRadius: "0 20px 20px 0" }}
              type="search"
              placeholder="Buscar eventos..."
              onChange={(e) => setSearch(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  onClick({ target: { name: "search" } });
                  document.querySelector('[data-bs-dismiss="offcanvas"]').click();
                }
              }}
            />
          </div>
        </div>

        {/* Navigation Menu */}
        <div className="p-3">
          <ul className="navbar-nav">
            {bar.map((menu, index) => {
              if (menu.dropdown) {
                const dropdownId = `menu-${index}`;
                const isOpen = openDropdown === dropdownId;
                return (
                  <li
                    key={index}
                    className={`nav-item mb-2 ${menu.show ? "" : "d-none"}`}
                  >
                    <button
                      className="btn w-100 text-start d-flex justify-content-between align-items-center py-3 px-3 bg-light"
                      style={{borderRadius: '12px', border: 'none'}}
                      onClick={() => toggleDropdown(dropdownId)}
                    >
                      <span className="fw-semibold d-flex align-items-center gap-2">
                        <i className="bi bi-grid-3x3-gap"></i>
                        {menu.name}
                      </span>
                      <i className={`bi bi-chevron-${isOpen ? 'up' : 'down'} transition-all`}></i>
                    </button>
                    <div
                      className="overflow-hidden"
                      style={{
                        maxHeight: isOpen ? `${menu.dropdown.length * 60}px` : '0px',
                        transition: 'max-height 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
                      }}
                    >
                      <ul className="list-unstyled ps-3 mt-2">
                        {menu.dropdown.map((submenu, subIndex) => {
                          return (
                            <li key={subIndex} className="mb-1">
                              <Link
                                className="btn btn-sm w-100 text-start text-dark text-decoration-none py-2 px-3"
                                to={submenu.link}
                                style={{borderRadius: '8px'}}
                                onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                                onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                              >
                                <i className="bi bi-arrow-right-short me-2"></i>
                                {submenu.name}
                              </Link>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  </li>
                );
              } else {
                return (
                  <li
                    key={index}
                    className={`nav-item mb-2 ${menu.show ? "" : "d-none"}`}
                  >
                    <Link
                      className="btn w-100 text-start py-3 px-3 bg-light fw-semibold"
                      style={{borderRadius: '12px', border: 'none'}}
                      to={menu.link}
                    >
                      <i className="bi bi-house-door me-2"></i>
                      {menu.name}
                    </Link>
                  </li>
                );
              }
            })}
          </ul>
        </div>

        {/* User Section */}
        <div className="p-3 border-top mt-auto">
          {me ? (
            <>
              <div className="card mb-3 border-0 bg-light">
                <div className="card-body p-3">
                  <div className="d-flex align-items-center gap-2 mb-3">
                    <div
                      className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center"
                      style={{width: '48px', height: '48px', fontSize: '18px', fontWeight: 'bold'}}
                    >
                      {me.nombre?.charAt(0)}{me.apellido?.charAt(0)}
                    </div>
                    <div className="flex-grow-1">
                      <div className="fw-semibold">{`${me.nombre} ${me.apellido}`}</div>
                      <div className="text-muted small">{me.email}</div>
                    </div>
                  </div>
                  <button
                    className="btn btn-sm w-100 text-start d-flex justify-content-between align-items-center py-2"
                    style={{borderRadius: '8px', border: '1px solid #dee2e6'}}
                    onClick={() => toggleDropdown('user')}
                  >
                    <span className="small">Mi cuenta</span>
                    <i className={`bi bi-chevron-${openDropdown === 'user' ? 'up' : 'down'}`}></i>
                  </button>
                  <div
                    className="overflow-hidden"
                    style={{
                      maxHeight: openDropdown === 'user' ? '300px' : '0px',
                      transition: 'max-height 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
                    }}
                  >
                    <ul className="list-unstyled mt-2 mb-0">
                      <li
                        className={`mb-1 ${me.roles[0].nombre == "adm" ||
                          me.roles[0].nombre == "prd" ||
                          me.roles[0].nombre == "sala"
                          ? ""
                          : "d-none"
                          }`}
                      >
                        <a
                          className="btn btn-sm w-100 text-start py-2"
                          href={"/dashboard/perfil"}
                          style={{borderRadius: '8px'}}
                        >
                          <i className="bi bi-speedometer2 me-2"></i>
                          Panel de Control
                        </a>
                      </li>
                      <li className="mb-1">
                        <button
                          className="btn btn-sm w-100 text-start py-2"
                          type="button"
                          data-bs-toggle="offcanvas"
                          data-bs-target="#offcanvasTop-membresia"
                          aria-controls="offcanvasTop-membresia"
                          style={{borderRadius: '8px'}}
                        >
                          <i className="bi bi-credit-card me-2"></i>
                          Membresías
                        </button>
                      </li>
                      <li className="mb-1">
                        <button
                          className="btn btn-sm w-100 text-start py-2"
                          type="button"
                          data-bs-toggle="offcanvas"
                          data-bs-target="#offcanvasTop-entradas"
                          aria-controls="offcanvasTop-entradas"
                          style={{borderRadius: '8px'}}
                        >
                          <i className="bi bi-ticket-perforated me-2"></i>
                          Mis Entradas
                        </button>
                      </li>
                      <li className="mt-2 pt-2 border-top">
                        <button
                          className="btn btn-sm btn-danger w-100 text-start py-2"
                          onClick={(e) => Logout()}
                          style={{borderRadius: '8px'}}
                        >
                          <i className="bi bi-box-arrow-right me-2"></i>
                          Cerrar Sesión
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <button
              className="btn btn-dark w-100 d-flex align-items-center justify-content-center gap-2 py-3"
              style={{ borderRadius: "12px" }}
              name="login"
              onClick={(e) => {
                onClick(e);
                document.querySelector('[data-bs-dismiss="offcanvas"]').click();
              }}
            >
              <i className="bi bi-person-circle fs-5"></i>
              <span className="fw-semibold">Ingresar</span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default OfHeader;
